import React from 'react';

const TRUSTBOX_TYPES = {
  '5419b732fbfb950b10de65e5': {
    height: '24px',
    width: '100%',
  },
  '53aa8807dec7e10d38f59f32': {
    height: '120px',
    width: '100%',
  },
  '5419b6ffb0d04a076446a9af': {
    height: '20px',
    width: '100%',
  },
  '5613c9cde69ddc09340c6beb': {
    height: '100%',
    width: '250px',
  },
};

export type TrustBoxType = keyof typeof TRUSTBOX_TYPES;

interface TrustBoxProps {
  theme?: string;
  type?: TrustBoxType;
}

const TrustBox: React.FC<TrustBoxProps> = ({
  theme = 'light',
  type = '5419b732fbfb950b10de65e5',
}) => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className='trustpilot-widget'
      data-locale='en-US'
      data-template-id={type}
      data-businessunit-id='60ae96c09f902b0001b4569c'
      data-style-height={TRUSTBOX_TYPES[type]?.height}
      data-style-width={TRUSTBOX_TYPES[type]?.width}
      data-token='5db9c78b-d326-49cd-833f-4ff46d856fb1'
      data-theme={theme}
    >
      <a
        href='https://www.trustpilot.com/review/bunny.net'
        target='_blank'
        rel='noopener'
      >
        Trustpilot
      </a>
    </div>
  );
};
export default TrustBox;
